import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { eventsApi } from '../api/events';
import { getErrorMessage } from '../api/client';
import Spinner from '../components/ui/Spinner';
import TemplateRenderer from '../templates/TemplateRenderer';
import CoverIntro from '../components/CoverIntro';

export default function PublicEvent() {
  const { shortCode } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await eventsApi.getPublic(shortCode);
        setEvent(data);
      } catch (err) {
        setError(getErrorMessage(err));
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [shortCode]);

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50">
        <Spinner size="lg" className="text-brand-500" />
      </div>
    );
  }

  if (error || !event) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50 px-4">
        <div className="text-center max-w-md">
          <h1 className="text-xl font-extrabold mb-2">Invitación no disponible</h1>
          <p className="text-sm text-slate-500">
            {error || 'Este enlace no existe o el evento ya no está activo.'}
          </p>
        </div>
      </div>
    );
  }

  if (event.expired) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50 px-4">
        <div className="text-center max-w-md">
          <h1 className="text-xl font-extrabold mb-2">Esta invitación expiró</h1>
          <p className="text-sm text-slate-500">
            Si eres el organizador, puedes renovarla desde tu panel.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      {!entered ? (
        <CoverIntro
          event={event}
          cover={event.cover}
          onEnter={() => setEntered(true)}
        />
      ) : (
        <TemplateRenderer
          template={event.template}
          data={event.data}
          title={event.title}
          media={event.media || []}
          audio={event.audio || null}
          cover={event.cover || null}
        />
      )}
    </>
  );
}